import * as React from "react";
import { NumberTextBoxEditor } from "../../../../../../../react-core/Html/NumberTextBoxEditor";
import { DrawdownIncomeAmendmentInstruction } from "../../../../../../../Wrap/Models/Domains/Drawdown/DrawdownIncomeAmendmentInstruction";
import { DrawdownModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { DrawdownCalculationAction } from "../../../Common/SIPP/DrawdownDetails/Action/DrawdownCalculationAction";

interface IITFCIncomeProps extends IProcessComponentProps {
    data: DrawdownModel;
}

interface IITFCIncomeState {
    itfcIncomeAlert: boolean;
    itfcIncomeId: number;
}

export class ITFCIncome extends ProcessComponent<IITFCIncomeProps, IITFCIncomeState> {
    constructor(props: any) {
        super(props);
        this.state = {
            itfcIncomeAlert: false,
            itfcIncomeId: null,
        };
    }

    private validateId = (id) => {
        if (!id) {return;}
        DrawdownCalculationAction.validateITFCIncomeId(id, (d) => {
            if (d.length > 0 || !d) {
                this.setState({ itfcIncomeAlert: true });
            } else {
                const _data: DrawdownIncomeAmendmentInstruction = JSON.parse(JSON.stringify(d));
                // Mock up
                _data.Income.TaxableIncomeRequiredInAddition = true;
                _data.Income.MaximumIncomePerPayment = { Amount: 1000 };
                _data.Income.MaximumInitialIncomePayment = { Amount: 1000 };
                this.props.onChange({ Income: _data.Income });
            }
        });
    };

    public render(): JSX.Element {
        return (
            <>
                <div className="row">
                    <div className="col-4">
                        <NumberTextBoxEditor
                            label="ITFC Income ID (optional)"
                            validateOnTyping={false}
                            //regex={{ value: Numeric7, errorMessage: "Invalid format, please re-enter" }}
                            onChange={(v) => {
                                this.setState({ itfcIncomeAlert: false, itfcIncomeId: v });
                            }}
                            maxLength={7}
                            value={this.state.itfcIncomeId}
                            cssWrapper="control-size-245"
                        />
                    </div>
                    <div className="col-4">
                        <button
                            className="btn secondary mr-10 mt-30"
                            onClick={() => {
                                this.validateId(this.state.itfcIncomeId);
                            }}
                        >
                            Validate
                        </button>
                    </div>
                </div>
                {this.state.itfcIncomeAlert && (
                    <Alert alertType={AlertType.Error} message={"ITFC request id is not valid"} />
                )}
            </>
        );
    }
}
